import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BAC_ACADEMIC_DATA } from './bac-academics.data';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-academics',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-academics.component.html',
  styleUrl: './bac-academics.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacAcademicsComponent extends BaseComponent {
  public BAC_ACADEMIC_DATA = BAC_ACADEMIC_DATA;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
